import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import Transition from '../../Transition/index.esm.js';
import { useModalContext } from '../context.esm.js';

var ModalOverlay = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useModalContext = useModalContext(),
      getOverlayProps = _useModalContext.getOverlayProps;

  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["children"]);

  var overlayProps = getOverlayProps(_extends({}, rest, {
    ref: ref
  }));
  return React__default.createElement(Transition, {
    enter: ['ease-out', 'duration-300'],
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: ['ease-in', 'duration-200'],
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, React__default.createElement(Box, _extends({
    position: "fixed",
    inset: "inset-0",
    backdropFilter: "backdrop-blur-1",
    transitionProperty: "transition-opacity",
    "aria-hidden": "true",
    zIndex: "z-50"
  }, overlayProps), React__default.createElement(Box, {
    position: "absolute",
    inset: "inset-0",
    backgroundColor: "bg-gray-700",
    opacity: "opacity-75"
  }, children)));
});

if (__DEV__) {
  ModalOverlay.displayName = 'ModalOverlay';
}

export default ModalOverlay;
export { ModalOverlay };
//# sourceMappingURL=index.esm.js.map
